import React from 'react';

interface NodePerspectivePillProps {
  perspectivePill: string | null;
  isVisibleGlobal: boolean;
  connectingArrows?: string;
  onToggleVisibility: (
    e:
      | React.MouseEvent<HTMLDivElement, MouseEvent>
      | React.KeyboardEvent<HTMLDivElement>
  ) => void;
}

const NodePerspectivePill: React.FC<NodePerspectivePillProps> = ({
  perspectivePill,
  isVisibleGlobal,
  connectingArrows,
  onToggleVisibility,
}) => {
  if (!perspectivePill) return null;

  return (
    <div
      className="node-perspective-label"
      style={{ width: 'auto', cursor: 'pointer' }}
      role="button"
      tabIndex={0}
      onClick={onToggleVisibility}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onToggleVisibility(e);
        }
      }}
    >
      <span>
        <i className={connectingArrows}></i>
      </span>
      {isVisibleGlobal && <span className='pill-text white-space-nowrap overflow-hidden text-overflow-ellipsis'>{perspectivePill}</span>}
    </div>
  );
};

export default NodePerspectivePill;
